/**
 * @file Created on Mon Oct 08 2018
 * @author LZe
 */
import Search from './Search';
export default Search;